import { render } from "./PaymentPlans.vue?vue&type=template&id=1a268b3a&scoped=true"
import script from "./PaymentPlans.vue?vue&type=script&lang=js"
export * from "./PaymentPlans.vue?vue&type=script&lang=js"

import "./PaymentPlans.vue?vue&type=style&index=0&id=1a268b3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a268b3a"]])

export default __exports__